import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CompetitionIndexComponent } from './index/index.component'
import { OperationsGuard } from '../operation/operations.guard'
import { CompetitionDetailsComponent } from './competition-team/competition-details/competition-details.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [OperationsGuard],
    component: CompetitionIndexComponent
  },
  {
    path: ':competitionId',
    pathMatch: 'full',
    canActivate: [OperationsGuard],
    component: CompetitionDetailsComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompetitionRoutingModule {}
